(function ($) {
    $(document).ready(function () {

        const splideElement = document.querySelector('.splide-featured-images');

        if (splideElement) {
            // Initialize the Featured Images Slider only if the element exists
            var splideImages = new Splide('.splide-featured-images', {
                type    : 'loop',
                perPage : 1,
                gap     : '50px',
                pagination: false,
                arrows  : true,
                easing     : 'ease-in-out',
                autoplay: "play",
                reducedMotion: {
                    interval: 6000,
                    speed: 1000,
                    autoplay: "play"
                },
                speed      : 1000,  
            
                breakpoints: {
                    782: {
                        gap     : '20px',
                    },
                    1024: {
                        gap     : '35px',
                    },
                },
            }).mount();
        } else {
            console.warn("Splide element '.splide-featured-images' not found on this page.");
        }

    });
})(jQuery);
